import Resource from 'components/global/Resource'
import SectionTitle from 'components/global/SectionTitle'
import { Section, Row, Col } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import { documentsUnderReview } from '../../../constants'
import { sortToolkits } from 'components/core-adoption/functions/sortToolkits'

export default function EnglishToolkitsSecondary({ ...props }) {
	const { account } = useContext(CoreAdoptionContext)
	return (
		<Section id={formatSectionId(props)} className="scroll-mt-14">
			<SectionTitle
				title="IRLA Toolkits for Secondary Grades"
				text="IRLA Toolkits for Secondary Grades help secondary teachers (Grades 6–12) make the shift to delivering targeted reading instruction in small groups organized by student need. IRLA Toolkits for Secondary Grades are available in 1B–Bk, and IRLA Toolkits in Or and Pu are also available to support secondary students."
			/>
			<Row className="justify-center">
				{account?.toolkits
					.filter((t) => t.active && t.language === 'english' && t.is_secondary === true)
					.sort(sortToolkits)
					.map((doc) => {
						return (
							<Col width="w-1/2 sm:w-1/3 md:w-1/6" className="mb-8" key={doc.name}>
								<Resource
									logResourceView={{ type: 'document' }}
									noLink={documentsUnderReview.includes(doc.name)}
									protected={!documentsUnderReview.includes(doc.name)}
									title={doc.name}
									text={documentsUnderReview.includes(doc.name) ? 'Under Revision for 2023' : doc.name}
								/>
							</Col>
						)
					})}
			</Row>
		</Section>
	)
}
